import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";
import { NotificationCenter } from "@/components/NotificationCenter";

export const Route = createFileRoute("/_authenticated/admin/notifications")({
  head: () => ({
    meta: [
      { title: "Notifications · Landoo Admin" },
      {
        name: "description",
        content: "Moderation alerts, verification updates and platform events for Landoo admins.",
      },
      { property: "og:title", content: "Notifications · Landoo Admin" },
      {
        property: "og:description",
        content: "Moderation alerts, verification updates and platform events for Landoo admins.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Notifications" role="Admin" items={ADMIN_NAV}>
      <NotificationCenter />
    </DashboardShell>
  ),
});
